import { render, staticRenderFns } from "./OutboundDetailed.vue?vue&type=template&id=2c22b0d8&scoped=true&"
import script from "./OutboundDetailed.vue?vue&type=script&lang=js&"
export * from "./OutboundDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22b0d8",
  null
  
)

export default component.exports